import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { FlyInTransition } from '../transitions/transitions';
import Modal from '../../containers/common/Modal';
import StyledTappable from '../common/StyledTappable';
import { getLanguages } from '../../services';
import { PrimaryButton } from '../../components/common/Buttons';

import plusIcon from '../../images/consultations/plus-icon.svg';
import crossIcon from '../../images/cross_icon.svg';
import searchIcon from '../../images/search.svg';
import crossIcon2 from '../../images/cross.svg';
import checkedRounded from '../../images/lab-test/checked.svg';
import emptyCheck from '../../images/consultations/new-flow/check-1.svg';
import reloadIcon from '../../images/home/reload-icon.svg';
import downArrow from '../../images/consultations/down-arrow.svg';

const FilterHeading = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 30px;
  justify-content: center;
  font-size: 13px;
  font-weight: ${(props) => (props.$active ? '600' : '500')};
  line-height: 21px;
  text-align: left;
  cursor: pointer;
  color: ${(props) => (props.$active ? 'var(--primary-button)' : '#585969')};
  border-bottom: 2px solid
    ${(props) => (props.$active ? 'var(--primary-button)' : '#fff')};
  &:active {
    opacity: 0.2;
  }
  @media (min-width: 440px) {
    font-size: 14px;
  }
`;
const PopularLangTag = styled(StyledTappable)`
  width: fit-content;
  height: 30px;
  padding: 6px 8px;
  gap: 2px;
  display: flex;
  gap: 6px;
  border-radius: 8px;
  background: #f1edff;

  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  cursor: pointer;
`;
const SearchSuggestions = styled.div`
  border-radius: 12px;
  overflow: hidden;
  max-width: 400px;
  width: 100%;
  max-height: 350px;
  position: absolute;
  top: 3rem;
  background: #fff;
  box-shadow: 2px 2px 8px 0px #0f0b2829;
`;
const DropdownOption = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f1edff;
  gap: 10px;
  padding: 10px;
  justify-content: space-between;
  width: 100%;
  font-weight: 500;
  cursor: pointer;

  font-size: 14px;
  color: ${(props) => (props.$selected ? 'var(--primary-button)' : '#585969')};
`;
const PurpleRound = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${(props) => (props.$fill ? 'var(--primary-button)' : '#fff')};
`;
export const RedDot = styled.div`
  height: 5px;
  width: 5px;
  position: absolute;
  top: 14px;
  right: 20px;
  border-radius: 50%;
  background: #fe4f1a;
`;
const filters = [
  {
    id: 1,
    name: 'Language',
  },
  {
    id: 2,
    name: 'Gender',
  },
  {
    id: 3,
    name: 'Availability',
  },
];

function ClearFilter(props) {
  return (
    <span
      className="text-primary border-b border-primary text-body-s"
      onClick={props?.onTap}
    >
      Clear Filter
    </span>
  );
}
function DoctorFilterModal(props) {
  const { authToken } = useSelector((state) => state.user);
  const {
    filterModal,
    hideModal,
    selectedVerticalId,
    onApplyFilter,
    appliedFilters,
  } = props;
  const [filterActive, setFilterActive] = useState(1); // 1 - Language, 2 - Gender, 3 - Availability
  const [allLanguages, setAllLanguages] = useState([]);
  const [popularLanguages, setPopularLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectedAvailability, setSelectedAvailability] = useState(null);
  const [enableCTA, setEnableCTA] = useState(false);

  useEffect(() => {
    if (appliedFilters) {
      setSelectedLanguages(appliedFilters?.language);
      setSelectedGender(appliedFilters?.gender);
      setSelectedAvailability(appliedFilters?.availability);
    }
  }, [appliedFilters]);

  function checkEnableCTA() {
    const { language, gender, availability } = appliedFilters;
    if (
      selectedLanguages?.sort().toString() === language.sort().toString() &&
      selectedGender?.id === gender?.id &&
      selectedAvailability?.id === availability?.id
    ) {
      setEnableCTA(false);
    } else {
      setEnableCTA(true);
    }
  }

  const languages = useCallback(async () => {
    try {
      const data = await getLanguages(authToken, selectedVerticalId);
      const { allLanguages, popularLanguages } = data;
      setAllLanguages(allLanguages);
      setPopularLanguages(popularLanguages);
    } catch (err) {
      console.error(err);
    }
  }, [authToken, selectedVerticalId]);

  function onReset() {
    setSelectedLanguages([]);
    setSelectedGender(null);
    setSelectedAvailability(null);
    onApplyFilter([], null, null);
  }

  useEffect(() => {
    languages();
  }, []);

  return (
    <Modal>
      <div className="modalContainer">
        <FlyInTransition in={filterModal} mountOnEnter unmountOnExit appear>
          <div
            className="bg-textbox fixed bottom-0px w-full  rounded-t-12px pb-8"
            style={{
              borderRadius: '12px 12px 0 0',
              fontSize: '14px',
              height: '450px',
            }}
          >
            <div className="p-20 border-b border-txtsecondary-shades7 border-solid flex flex-row items-center justify-between w-full">
              <span className="text-title-s ml-10px font-semibold text-txtlight">
                Select Filter
              </span>
              <div className="flex items-center justify-center gap-4 text-body-s">
                <div
                  className="flex items-center justify-center gap-2 border rounded-8 border-secondary-shades1 px-2 py-1 cursor-pointer"
                  onClick={onReset}
                >
                  <img src={reloadIcon} alt="reload" height="16" width="16" />
                  Reset
                </div>
                <img src={crossIcon} alt="cross" onClick={hideModal} />
              </div>
            </div>
            <div className="  overflow-y-auto h-full">
              <div className="flex  w-full h-12 justify-between border-b border-txtsecondary-shades7 border-solid">
                {filters.map((filter, index) => (
                  <FilterHeading
                    key={`filter-${index}`}
                    $active={filterActive === filter.id}
                    onClick={() => setFilterActive(filter.id)}
                  >
                    {filter?.id === 1 && selectedLanguages?.length > 0 && (
                      <RedDot />
                    )}
                    {filter?.id === 2 && selectedGender && <RedDot />}
                    {filter?.id === 3 && selectedAvailability && <RedDot />}
                    {filter.name}
                  </FilterHeading>
                ))}
              </div>
              {filterActive === 1 && (
                <LanguageFilterView
                  allLanguages={allLanguages}
                  popularLanguages={popularLanguages}
                  selectedLanguages={selectedLanguages}
                  setSelectedLanguages={setSelectedLanguages}
                  checkEnableCTA={checkEnableCTA}
                />
              )}
              {filterActive === 2 && (
                <GenderFilterView
                  selectedGender={selectedGender}
                  setSelectedGender={setSelectedGender}
                  checkEnableCTA={checkEnableCTA}
                />
              )}
              {filterActive === 3 && (
                <AvailabilityFilterView
                  selectedAvailability={selectedAvailability}
                  setSelectedAvailability={setSelectedAvailability}
                  checkEnableCTA={checkEnableCTA}
                />
              )}
            </div>
            <div className=" absolute bottom-0 w-full flex justify-center items-center h-112px py-6 px-5  border-t-2 border-txtlight-shades3 z-10 bg-textbox">
              {enableCTA}
              <PrimaryButton
                disabled={!enableCTA}
                className=" text-center text-16px text-white w-full font-bold rounded-12"
                onTap={() => {
                  onApplyFilter(
                    selectedLanguages,
                    selectedGender,
                    selectedAvailability
                  );
                }}
              >
                Apply Filters
              </PrimaryButton>
            </div>
          </div>
        </FlyInTransition>
      </div>
    </Modal>
  );
}

export default DoctorFilterModal;

function LanguageFilterView(props) {
  const {
    allLanguages,
    popularLanguages,
    selectedLanguages,
    setSelectedLanguages,
    checkEnableCTA,
  } = props;
  const [search, setSearch] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  function clickDropdownOption(lang) {
    if (!selectedLanguages?.find((p) => p.languageId === lang.languageId)) {
      setSelectedLanguages((prev) => [
        ...prev,
        {
          languageId: lang.languageId,
          languageName: lang.languageName,
        },
      ]);
    } else {
      setSelectedLanguages(
        selectedLanguages?.filter((p) => {
          return p.languageId !== lang.languageId;
        }) || []
      );
    }
  }

  const onChange = useCallback(
    (text) => {
      // find languages that start with the text and put in suggestions
      const filteredLanguages = allLanguages?.filter((lang) =>
        lang.languageName.toLowerCase().startsWith(text.toLowerCase())
      );
      setSuggestions(filteredLanguages);
    },
    [allLanguages]
  );

  useEffect(() => {
    checkEnableCTA();
  }, [selectedLanguages, checkEnableCTA]);

  useEffect(() => {
    // debouncing search
    const timer = setTimeout(() => {
      if (!search) return;
      onChange(search);
    }, 300);
    return () => clearTimeout(timer);
  }, [search, onChange]);

  return (
    <>
      <div className="flex flex-col p-20 gap-2 relative">
        {selectedLanguages?.length > 0 && (
          <div className="flex justify-between items-center">
            <span>Selected Languages</span>
            {selectedLanguages && (
              <ClearFilter onTap={() => setSelectedLanguages([])} />
            )}
          </div>
        )}
        <div className="flex gap-2">
          {selectedLanguages?.map((lang) => (
            <PopularLangTag
              onTap={() => {
                setSelectedLanguages(
                  selectedLanguages?.filter((p) => {
                    return p?.languageId !== lang?.languageId;
                  }) || []
                );
              }}
            >
              <span>{lang.languageName}</span>
              <img src={crossIcon2} alt="cross" height={8} width={8} />
            </PopularLangTag>
          ))}
        </div>
        <div className="flex justify-between items-center">
          <span>Search languages</span>
          {selectedLanguages?.length > 0 && (
            <span className="text-primary">
              {selectedLanguages?.length} selected
            </span>
          )}
        </div>
        <div className="relative">
          <div className="rounded-12 border border-primary p-12px flex gap-2 items-center h-11">
            <img src={searchIcon} alt="search" />
            <input
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              type="text"
              placeholder="Search languages"
              className="w-full border-none font-semibold text-title-s"
            />
            <img src={crossIcon2} alt="cross" onClick={() => setSearch('')} />
          </div>
          {search ? (
            suggestions?.length > 0 ? (
              <SearchSuggestions>
                {suggestions?.map((lang) => (
                  <DropdownOption
                    onClick={() => {
                      clickDropdownOption(lang);
                    }}
                  >
                    <span>{lang.languageName}</span>
                    {selectedLanguages?.find(
                      (l) => l.languageId === lang.languageId
                    ) ? (
                      <img src={checkedRounded} alt="tick" />
                    ) : (
                      <img src={emptyCheck} alt="untick" className="mr-1" />
                    )}
                  </DropdownOption>
                ))}
              </SearchSuggestions>
            ) : (
              <SearchSuggestions>
                <DropdownOption>
                  <span>No results found</span>
                </DropdownOption>
              </SearchSuggestions>
            )
          ) : (
            ''
          )}
        </div>
        <span>Popular Languages</span>
        <div className="flex gap-2">
          {popularLanguages?.map((lang) => (
            <PopularLangTag
              onTap={() => {
                if (
                  !selectedLanguages?.find(
                    (p) => p.languageId === lang.language
                  )
                )
                  setSelectedLanguages((prev) => [
                    ...prev,
                    {
                      languageId: lang.language,
                      languageName: lang.languageName,
                    },
                  ]);
              }}
            >
              <span>{lang?.languageName}</span>
              <img src={plusIcon} alt="plus" height={16} width={16} />
            </PopularLangTag>
          ))}
        </div>
      </div>
    </>
  );
}

function GenderFilterView(props) {
  const { selectedGender, setSelectedGender, checkEnableCTA } = props;
  const [dropdown, setDropdown] = useState(true);
  const genderOptions = [
    {
      id: 1,
      name: 'Male',
      key: 'gen-m',
    },
    {
      id: 2,
      name: 'Female',
      key: 'gen-f',
    },
  ];
  function clickDropdownOption(g) {
    if (selectedGender?.id !== g.id) setSelectedGender(g);
    else setSelectedGender(null);
  }
  useEffect(() => {
    checkEnableCTA();
  }, [selectedGender]);
  return (
    <>
      <div className="flex flex-col p-20 gap-2 relative">
        <div className="flex justify-between items-center">
          <span>Select Gender</span>
          {selectedGender && (
            <ClearFilter onTap={() => setSelectedGender(null)} />
          )}
        </div>
        <div className="relative">
          <div className="rounded-12 border border-primary p-12px flex gap-2 items-center h-11">
            <div
              onClick={() => setDropdown(!dropdown)}
              className="w-full border-none font-medium text-title-s"
            >
              {selectedGender ? (
                selectedGender?.name
              ) : (
                <div className="text-txtlight-shades1 font-medium">
                  Please select gender
                </div>
              )}
            </div>
            {selectedGender?.id && (
              <img
                src={downArrow}
                alt="cross"
                onClick={() => setSelectedGender(null)}
              />
            )}
          </div>
          {dropdown && (
            <SearchSuggestions>
              {genderOptions?.map((g) => (
                <DropdownOption
                  onClick={() => {
                    clickDropdownOption(g);
                  }}
                >
                  <span>{g?.name}</span>
                  <div className="border-2 border-primary rounded-full p-2px h-fit w-fit">
                    {selectedGender?.id === g.id ? (
                      <PurpleRound $fill />
                    ) : (
                      <PurpleRound />
                    )}
                  </div>
                </DropdownOption>
              ))}
            </SearchSuggestions>
          )}
        </div>
      </div>
    </>
  );
}

function AvailabilityFilterView(props) {
  const { selectedAvailability, setSelectedAvailability, checkEnableCTA } =
    props;
  const [dropdown, setDropdown] = useState(true);
  const genderOptions = [
    {
      id: 1,
      name: 'Now',
      key: 'yes',
    },
    {
      id: 2,
      name: 'Later',
      key: 'no',
    },
  ];
  function clickDropdownOption(g) {
    if (selectedAvailability?.id !== g.id) setSelectedAvailability(g);
    else setSelectedAvailability(null);
  }
  useEffect(() => {
    checkEnableCTA();
  }, [selectedAvailability]);
  return (
    <>
      <div className="flex flex-col p-20 gap-2 relative">
        <div className="flex justify-between items-center">
          <span>Select Availability</span>
          {selectedAvailability && (
            <ClearFilter onTap={() => setSelectedAvailability(null)} />
          )}
        </div>
        <div className="relative">
          <div className="rounded-12 border border-primary p-12px flex gap-2 items-center h-11">
            <div
              onClick={() => setDropdown(!dropdown)}
              className="w-full border-none font-medium text-title-s"
            >
              {selectedAvailability ? (
                selectedAvailability?.name
              ) : (
                <div className="text-txtlight-shades1 font-medium">
                  Please select availability
                </div>
              )}
            </div>
            {selectedAvailability && (
              <img
                src={downArrow}
                alt="cross"
                onClick={() => setSelectedAvailability(null)}
              />
            )}
          </div>
          {dropdown && (
            <SearchSuggestions>
              {genderOptions?.map((g) => (
                <DropdownOption
                  onClick={() => {
                    clickDropdownOption(g);
                  }}
                >
                  <span>{g?.name}</span>
                  <div className="border-2 border-primary rounded-full p-2px h-fit w-fit">
                    {selectedAvailability?.id === g.id ? (
                      <PurpleRound $fill />
                    ) : (
                      <PurpleRound />
                    )}
                  </div>
                </DropdownOption>
              ))}
            </SearchSuggestions>
          )}
        </div>
      </div>
    </>
  );
}
